// Lib
import { FC, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
// Api
import { useGetCustomersQuery } from "redux/query/customersAPI";
// Hooks
import { useDebounce, useNotification, useTable } from "hooks";
// Types
import { TablePaginationConfig } from "antd/es/table";
import { FilterValue } from "antd/es/table/interface";
import { ETable } from "types/tableFilters";
// Theme
import { theme } from "theme";
// Constants
import { rtkQueryParams } from "consts";
// Icons
import { AddIcon, DescriptionBlackIcon } from "icons";
// Helpers
import { getFiltersQuery } from "helpers/tableFiltersHelpers";
// Utils
import { errorHandler } from "utils/errorHandler";
// Components
import {
  //TODO: remove comment if BE is ready
  // Export,
  Pagination,
  Table,
} from "components";
import { TopUpBalanceModal } from "components/Modals";
// Styled
import { FlexContainer, PageWrapper } from "styled/Box";
import { SelectedItems, Typography } from "styled/Typography";
import { Button } from "styled/Buttons";

import { columns, filtersList } from "./config";

export const Customers: FC = () => {
  const navigate = useNavigate();
  const { openNotification } = useNotification();

  const {
    sortingOrder,
    sortBy,
    offset,
    limit,
    //TODO: remove comment if BE is ready
    // search,
    debouncedSearch,
    selectedFilters,
    setOffset,
    setLimit,
    //TODO: remove comment if BE is ready
    // setSearch,
    handleSort,
    handleSetTableFilterValues,
  } = useTable({ name: ETable.Customers });

  const filtersQuery = getFiltersQuery(selectedFilters);

  const query = useDebounce<Record<string, string | string[]>>(
    filtersQuery,
    500,
  );

  const {
    data: customersData,
    isFetching: isLoading,
    error: customersError,
  } = useGetCustomersQuery(
    {
      query: {
        ...(query && query),
        offset,
        limit,
        sortBy,
        sortingOrder,
        search: debouncedSearch,
      },
    },
    rtkQueryParams,
  );

  useEffect(() => {
    if (customersError) {
      errorHandler({ error: customersError, openNotification });
    }
  }, [customersError]);

  const [
    selected,
    //TODO: remove comment if BE is ready
    // , setSelected
  ] = useState<string[]>([]);
  const [topUpBalanceModal, setTopUpBalanceModal] = useState<boolean>(false);

  const cleanColumns = useMemo(() => {
    return columns.map((col, i) => ({
      ...col,
      title:
        i === 0 ? (
          <FlexContainer $align="center" style={{ position: "relative" }}>
            <SelectedItems>{`${selected.length} data selected`}</SelectedItems>

            <Button.SubHeading
              onClick={() => setTopUpBalanceModal(true)}
              style={{
                marginLeft: 24,
                marginRight: -30,
                marginTop: -4,
                marginBottom: -4,
              }}
              icon={<AddIcon fill={theme.color.black} />}
            >
              Bulk Top up Balance
            </Button.SubHeading>
          </FlexContainer>
        ) : null,
      sorter: false,
    }));
  }, [selected.length]);

  const handleTableChange = (
    _pagination: TablePaginationConfig,
    _filters: Record<string, FilterValue>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    sorter: any,
  ) => {
    handleSort(sorter?.field, sorter?.order);
  };

  const onRow = record => {
    return {
      onClick: () => {
        navigate(`/customers/${record.id}`);
      },
    };
  };

  //TODO: remove comment if BE is ready
  // const rowSelection = {
  //   onChange: (_: React.Key[], selectedRows: any[]) => {
  //     setSelected(selectedRows.map(row => row.id));
  //   },
  // };

  return (
    <>
      <PageWrapper $fullwidth $column>
        <FlexContainer $fullwidth $column $grow={1} $padding="0 0 32px">
          <FlexContainer
            $padding="0 0 24px"
            $align="center"
            $justify="space-between"
          >
            <Typography.H1>Customers</Typography.H1>

            {/* //TODO: remove comment if BE is ready */}
            {/* <Export /> */}
          </FlexContainer>

          <Table
            isLoading={isLoading}
            rowKey={record => record.id}
            dataSource={customersData?.items || []}
            columns={!selected?.length ? columns : cleanColumns}
            empty={{
              icon: DescriptionBlackIcon,
              title: "No customer to show.",
              description: "Try changing sections or change the filters",
            }}
            header={{
              //TODO: remove comment if BE is ready
              // search: {
              //   placeholder: "Search name or phone number",
              //   value: search,
              //   setValue: setSearch,
              // },
              totalCount: customersData?.totalCount,
              filter: {
                filters: filtersList,
                selected: selectedFilters,
                setValue: handleSetTableFilterValues,
              },
            }}
            //TODO: remove and add request if BE is finished
            // rowSelection={{
            //   type: "checkbox",
            //   selectedRowKeys: selected,
            //   ...rowSelection,
            // }}
            onChange={handleTableChange}
            onRow={onRow}
          />
        </FlexContainer>

        <Pagination
          onPage
          padding="12px 16px"
          limit={limit}
          offset={offset}
          setLimit={setLimit}
          setOffset={setOffset}
          totalItems={customersData?.totalCount}
        />
      </PageWrapper>

      <TopUpBalanceModal
        onSave={data => console.log(data)}
        open={topUpBalanceModal}
        isLoading={false}
        onClose={() => setTopUpBalanceModal(false)}
      />
    </>
  );
};
